module.exports = __webpack_public_path__ + "img/velas-icon.fd0d8fb1.svg";